import { useContext } from "react";
import WizardContext from "./WizardContext";

const useWizardContext = () => useContext(WizardContext);

export default useWizardContext;
